import { render, staticRenderFns } from "./DlvL.vue?vue&type=template&id=54a4e3b0"
import script from "./DlvL.vue?vue&type=script&lang=js"
export * from "./DlvL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports